import { render, staticRenderFns } from "./VotingDescription.vue?vue&type=template&id=34ab32c3&scoped=true"
import script from "./VotingDescription.vue?vue&type=script&lang=js"
export * from "./VotingDescription.vue?vue&type=script&lang=js"
import style0 from "./VotingDescription.vue?vue&type=style&index=0&id=34ab32c3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34ab32c3",
  null
  
)

export default component.exports